import { render } from "./write_review.vue?vue&type=template&id=0f015b55"
import script from "./write_review.vue?vue&type=script&lang=js"
export * from "./write_review.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__